import { render, staticRenderFns } from "./alertMissionCollege.vue?vue&type=template&id=3a11af80&scoped=true&"
import script from "./alertMissionCollege.vue?vue&type=script&lang=js&"
export * from "./alertMissionCollege.vue?vue&type=script&lang=js&"
import style0 from "./alertMissionCollege.vue?vue&type=style&index=0&id=3a11af80&scoped=true&lang=css&"
import style1 from "./alertMissionCollege.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a11af80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VContainer,VIcon,VRow})
